import { useEffect } from 'react';
import matGroupService from '../../services/api/matGroupService';

// Debounced group duplicate check. It is keyed on the group's actual NAME (and, when
// given, its GUID), never the Group dropdown's category label ("MAT", "Group", …) — that
// label is not a unique name and must never reach the duplicate endpoint. `excludeId`
// lets the edit surface exclude the group being edited from its own check. A last-wins
// latch stops a slow, superseded response from clobbering a newer result.
export default function GroupDuplicateWatch({ name, groupUid, excludeId, onResult }) {
  useEffect(() => {
    const n = (name || '').trim();
    const g = (groupUid || '').trim();
    if (!n && !g) {
      onResult(null);
      return undefined;
    }
    let current = true;
    const timer = setTimeout(() => {
      matGroupService.checkDuplicate(n, g, excludeId).then((result) => {
        if (current) onResult(result && result.isDuplicate ? result : null);
      });
    }, 500);
    return () => {
      current = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, groupUid, excludeId]);
  return null;
}
